export default {
    providerId: '',
    stableCoins: [],
};
